import React, { useContext } from "react";

import { Button } from "components";

import FiltersContext from "./filtersContext";

import Reset from "static/images/reset.png";
import styles from "./filter.module.scss";

export type FilterActionProps = {
	onApply?: React.MouseEventHandler<HTMLButtonElement>;
	onReset?: React.MouseEventHandler<HTMLButtonElement>;
	onHandleExtractData?: Function | undefined;
	showExtractButton?: boolean;
};

const FilterActions = ({
	onApply,
	onReset,
	onHandleExtractData = undefined,
	showExtractButton = false,
}: FilterActionProps) => {
	const { isApplyDisabled } = useContext(FiltersContext);

	return (
		<div className={styles.filterActions}>
			<Button
				type="submit"
				variant="secondary"
				minWidth="auto"
				onClick={onApply}
				className={styles.applyBtn}
				value="Apply"
				disabled={isApplyDisabled}
			/>

			{showExtractButton && (
				<>
					<div className="vl ml-1 mr-1" />
					<Button
						variant="secondary"
						minWidth="auto"
						onClick={onHandleExtractData}
						className={styles.applyBtn}
						value="Extract"
					/>
				</>
			)}
			<div className="vl ml-1 mr-2" />
			<Button
				btnIcon
				variant="secondary"
				onClick={onReset}
				icon={<img src={Reset} width="12" alt="" />}
			/>
		</div>
	);
};

export default FilterActions;
